/* file description */

import { ProFormInstance } from '@ant-design/pro-form';

interface UseChangeRow {
  rowFormRef: React.MutableRefObject<ProFormInstance | undefined>;
  rowValueChange: (index: number, value: Record<string, any>) => void;
  clickRowIndex: React.MutableRefObject<number | undefined>;
  setEditPopupVisible: (value: boolean) => void;
}

export const useChangeRow = ({ rowFormRef, rowValueChange, clickRowIndex, setEditPopupVisible }: UseChangeRow) => {
  const changeRow = async () => {
    const values = await rowFormRef.current?.validateFields();
    rowValueChange(clickRowIndex?.current, values);
    setEditPopupVisible(false);
  };
  return {
    changeRow,
  };
};
